import styled from 'styled-components';

const Wrapper = styled.section`
  

  img {
    height: 175px;
  }

  .products-container {
    display: flex;
    gap: 2rem 1.5rem;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    flex-wrap: wrap;
  }

  .Empty-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 50vh;
  }
  

  @media (min-width: 992px) {
    .products-container {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media (min-width: 1170px) {
    .products-container {
      grid-template-columns: repeat(3, 1fr);
    }
  }
`;

export default Wrapper;
